import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IVoucherSearchResult } from '../../../models/vouchers/voucher.search.result';
import { OregonWellDataService } from '../../../services/oregon-well-data.service';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { VoucherService } from 'app/services/voucher-service';
import { DialogEditVoucherComponent } from '../edit/voucher-edit-dialog';
import { DialogEditApplicationComponent } from '../edit/application-edit-dialog';
import { DialogMergeVouchersComponent } from './merge-vouchers-dialog-component';
import { AuthService } from '@shared/auth/auth.service';
import { IFuzzySearchResult } from 'app/models/common/fuzzySearchResult';

@Component({
  selector: 'app-search-vouchers',
  templateUrl: './search-vouchers.component.html',
  styleUrls: ['./search-vouchers.component.scss']
})
export class SearchVouchersComponent implements OnInit, AfterViewInit {
  pageSize = 20;
  processing = false;
  showResults = false;
  checkboxActionList: number[] = [];

  displayedColumns: string[] = ['selectRow', 'id', 'applicationId', 'applicationStatus', 'applicationType', 'wellId', 'wellAddress', 'wellCity', 'wellState', 'wellZip', 'wellCounty', 'wellLog', 'wellLabelTagNumber', 'score'];
  flatResults: IVoucherSearchResult[] = [];
  dataSource = new MatTableDataSource<IVoucherSearchResult>(this.flatResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  filterTable(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  constructor(public dialog: MatDialog,
    public voucherService: VoucherService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService) {

  }

  ngAfterViewInit(): void {
    // ngAfterViewInit
  }

  ngOnInit(): void {
    if (this.searchResultsCount > 0) {
      this.showResults = true;
      this.flatResults = this.getFlatSearchResults();
      this.dataSource = new MatTableDataSource<IVoucherSearchResult>(this.flatResults);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  openMergeVouchersDialog() {
    //let vouchers = this.voucherService.searchResults.filter(w => this.checkboxActionList.indexOf(Number(w.data.voucherId)) >= 0);
    let vouchers = this.voucherService.searchResults.filter(w => this.checkboxActionList.indexOf(Number(w.data.voucherId)) >= 0).map((result: any) => {
      return {
        voucherId: result.data?.voucherId || null,
        applicationIdentifier: result.data?.applicationIdentifier || null,
        applicationStatus: result.data?.applicationStatus || null,
        voucherType: result.data?.voucherType || null,
        voucherApplicationId: result.data?.voucherApplicationId || null,
        wellId: result.data?.wellId || null,
        wellAddress1: result.data?.wellAddress1 || '',
        wellCity: result.data?.wellCity || '',
        wellZip: result.data?.wellZip || '',
        wellCounty: result.data?.wellCounty || '',
        wellLog: result.data?.wellLog || '',
        wellTag: result.data?.wellTag || '',
        wellAddress2: result.data?.wellAddress2 || '',
        applicantContactName: result.data?.applicantContactName || '',
        applicantAddress: result.data?.applicantMailingAddress || '',
        applicantCity: result.data?.applicantCity || '',
        applicantState: result.data?.applicantState || '',
        applicantZip: result.data?.applicantZip || '',
        applicantContactEmail: result.data?.applicantContactEmail || '',
        applicationType: result.data?.applicationType || null,
        totalSamples: result.data?.totalSamples || 0
      } as any;
    });

    if (vouchers != undefined && vouchers.length > 0) {
      const dialogRef = this.dialog.open(DialogMergeVouchersComponent, {
        width: '1080px',
        data: vouchers,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result != "Cancel" && result != "Close") {
          this.onSubmit();
        }
      });
    }
  }

  clickCheckboxAction(voucherId: number) {
    let idx = this.checkboxActionList.indexOf(voucherId)
    if (idx >= 0) {
      this.checkboxActionList.splice(idx, 1);
    }
    else {
      this.checkboxActionList.push(voucherId);
    }
  }

  editVoucher(voucherId: number) {
    const dialogRef = this.dialog.open(DialogEditVoucherComponent, {
      width: '90%',
      data: voucherId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }

  editVoucherApplication(applicationId: number) {
    const dialogRef = this.dialog.open(DialogEditApplicationComponent, {
      width: '90%',
      data: applicationId,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.onSubmit();
    });
  }

  download() {
    let csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      showTitle: false,
      title: '',
      useBom: false,
      noDownload: false,

      // this order is the CSV layout
      // the headers match & are defined in: VoucherSearchResultViewModel object
      headers: [
        "OHAVoucherId", "OHAApplicationId", "VoucherIdentifier",
        "VoucherType", "OHAWellId",
        "ApplicantContactName", "ApplicantMailingAddress",
        "ApplicantCity", "ApplicantState",
        "ApplicantZip", "PreferredContactType", "PreferredContactComments",
        "ApplicantContactEmail", "ApplicantContactPhone", "VoucherMaxValue",
        "Redeemed", "ExceedencesDetected", "WellAddress1", "WellAddress2",
        "WellCity", "WellState",
        "WellZip", "WellCounty", "ApplicationStatus", "VoucherIssueDate", "SelfGeneratedVoucherIdentifer",
        "WellLog", "WellTag", "TotalSamples", "TotalLetters", "TestingNeed"
      ]
    };

    this.setFormFields();
    this.voucherService.DownloadCsv(this.voucherService.search).subscribe(
      result => {
        this.processing = false;
        return new AngularCsv(result, "Voucher_Search_Export", csvOptions);
      },
      error => {
        this.processing = false;
      }
    );
  }

  reset() {
    this.voucherService.searchForm.reset();
  }

  onSubmit() {
    this.checkboxActionList = [];
    this.setFormFields();
    this.processing = true;
    this.showResults = false;
    this.voucherService.Search(this.voucherService.search).subscribe(
      result => {
        this.voucherService.searchResults = result;
        this.voucherService.haveSearchResults = true;
        this.voucherService.searchResultsCount = this.voucherService.searchResults.length;
        this.searchResultsCount = this.voucherService.searchResults.length;
        this.processing = false;
        this.showResults = true;
      },
      error => {
        this.processing = false;
        this.showResults = false;
      },
      () => {
        this.flatResults = this.getFlatSearchResults();
        this.dataSource = new MatTableDataSource<IVoucherSearchResult>(this.flatResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  getFlatSearchResults(): any[] {
    return this.voucherService.searchResults.map((result: IFuzzySearchResult) => {
      return {
        voucherApplicationId: result.data?.voucherApplicationId || null,
        voucherType: result.data?.voucherType || null,
        voucherId: result.data?.voucherId || null,
        sampleId: result.data?.sampleId || null,
        wellAddress1: result.data?.wellAddress1 || '',
        wellCity: result.data?.wellCity || '',
        wellZip: result.data?.wellZip || '',
        wellCounty: result.data?.wellCounty || '',
        wellLog: result.data?.wellLog || '',
        wellTag: result.data?.wellTag || '',
        wellId: result.data?.wellId || null,
        applicationType: result.data?.applicationType || null,
        applicationStatus: result.data?.applicationStatus || null,
        applicationIdentifier: result.data?.applicationIdentifier || null,
        score: result.score || 0
      } as any;
    });
  }

  setFormFields() {
    this.voucherService.search.voucherId = this.voucherService.searchForm.value.voucherId;
    this.voucherService.search.voucherApplicationId = this.voucherService.searchForm.value.applicationId;
    this.voucherService.search.wellTag = this.voucherService.searchForm.value.wellTag;
    this.voucherService.search.wellLog = this.voucherService.searchForm.value.wellLog;
    this.voucherService.search.contact = this.voucherService.searchForm.value.contact;
    this.voucherService.search.county = this.voucherService.searchForm.value.county;
    this.voucherService.search.address = this.voucherService.searchForm.value.address;
    this.voucherService.search.city = this.voucherService.searchForm.value.city;
    this.voucherService.search.zip = this.voucherService.searchForm.value.zip;
    this.voucherService.search.county = this.voucherService.searchForm.value.county;
    this.voucherService.search.receivedStartDate = this.voucherService.searchForm.value.receivedStartDate;
    this.voucherService.search.receivedEndDate = this.voucherService.searchForm.value.receivedEndDate;
    this.voucherService.search.exceedencesDetected = this.voucherService.searchForm.get('exceedencesDetected').value != null ? this.voucherService.searchForm.get('exceedencesDetected').value : false;
    this.voucherService.search.redeemed = this.voucherService.searchForm.get('redeemed').value != null ? this.voucherService.searchForm.get('redeemed').value : false;
    this.voucherService.search.status = this.voucherService.searchForm.value.status;
    this.voucherService.search.type = this.voucherService.searchForm.value.type;
    this.voucherService.search.applicationIdentifier = this.voucherService.searchForm.value.applicationIdentifier;
  }

  searchResults(): IFuzzySearchResult[] {
    return this.voucherService.searchResults;
  }

  searchResultsCount = this.voucherService.searchResultsCount;
}

function DialogEditVoucherApplicationComponent(DialogEditVoucherApplicationComponent: any, arg1: { width: string; data: any; }) {
  throw new Error('Function not implemented.');
}